<div>
	<div class="modal-header">
		<h4 class="modal-title">Editer le dossier {{folderName}}</h4>
		<button type="button" class="close" aria-label="Close" (click)="cancelDialog()"><span aria-hidden="true">&times;</span></button>
	</div>

	<div class="modal-body">
		<form [formGroup]="folderEditForm">
			<div class="form-group">
				<label class="ls-label-strong" for="name">Nom du dossier</label>
				<input required #nameControl id="name" type="text" class="form-control" formControlName="nameControl" placeholder="Nom" ngbAutofocus>
			</div>

			<div class="form-group">
				<label class="ls-label-strong" for="folder_server">Dossier du serveur</label>
				<p-tree
					[value]="treeStructure"
					selectionMode="single"
					[(selection)]="selectedFolder"
					(onNodeSelect)="nodeSelect($event)"></p-tree>
			</div>

			<div class="form-group">
				<label class="ls-label-strong" for="engineer">Ingénieur associé</label>
				<select #engineerControl id="engineer" class="form-control" formControlName="engineerControl">
					<option *ngFor="let engineer of engineersList" [ngValue]="engineer._id">{{engineer.name}}</option>
				</select>
			</div>

			<div class="form-group">
				<label class="ls-label-strong" for="endDate">Date d'arrêt</label>
				<input required #endDateControl id="endDate" type="date" class="form-control" formControlName="endDateControl">
			</div>
		</form>
	</div>

	<div class="modal-footer">
		<button type="button" class="btn btn-light" (click)="cancelDialog()">Annuler</button>
		<button type="submit" class="btn btn-primary" [disabled]="!enableAction || !folderEditForm.valid" (click)="save()">{{buttonText}}</button>
	</div>
</div>
